import { locale, language, setup } from '@tcc/i18n';
import { setupI18n as setupProductPackagingI18n } from "@tcc/product-packaging-web"
import { i18nSetup as crateI18nSetup } from '@tcc/crate';
import englishFile from '../../i18n/en.json';

/**
 * Expose the global i18n values to the app props
 * @return {Promise}
 */
export default async function setupI18n() {
  const dmbI18nSetup = setup({
    project: {
      s3Name: 'dmb',
      smartlingName: 'dmb-web',
    },
    englishFile,
  });

  const productPackagingWebI18nSetup = setupProductPackagingI18n();
  const crateWebI18nSetup = crateI18nSetup();

  await Promise.all([dmbI18nSetup, crateWebI18nSetup, productPackagingWebI18nSetup]);


  return Promise.resolve({i18n: { locale, language }});
}
